import config from 'config';
import axios from 'axios';
import FileSaver from 'file-saver';

const ROOT = config.API_BASE_URL;

class GroupingsService {

  static getRoot() {
    return ROOT;
  }

  static getImage(fileName) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groupings/images/${fileName}`, {metadata: {serviceCall: 'GroupingsService.getImage'}}).then((data) => {
        resolve({ data: data.data, response: data });
      }).catch((err) => {
        // img does not exist
        reject(err);
      });
    });
  }

  static deleteImage(groupingId, fileName) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}groupings/${groupingId}/images/${fileName}`, {metadata: {serviceCall: 'GroupingsService.deleteImage'}}).then((data) => {
        resolve({ data: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static uploadImage(groupingId, file) {
    return new Promise((resolve, reject) => {
      var uploadData = new FormData();
      uploadData.append('file', file);

      axios.post(`${ROOT}groupings/${groupingId}/images`, uploadData, {metadata: {serviceCall: 'GroupingsService.uploadImage'}}).then((data) => {
        resolve({ data: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static uploadImageForAMT(groupingId, amtId, file) {
    return new Promise((resolve, reject) => {
      var uploadData = new FormData();
      uploadData.append('file', file);

      axios.post(`${ROOT}groupings/${groupingId}/amt/${amtId}/images`, uploadData, {metadata: {serviceCall: 'GroupingsService.uploadImageForAMT'}}).then((data) => {
        resolve({ amtData: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  // options: filterByGroupId
  static getAll(options=[], archived=false) {
    return new Promise((resolve, reject) => {
      var params = `?archived=${archived}`;
      params += options.length == 0 ? '' : '&' + options.map(option => Object.keys(option).map((k, i) => `${k}=${option[k]}`)).join('&');
      axios.get(`${ROOT}groupings${params}`, {metadata: {serviceCall: 'GroupingsService.getAll'}}).then((data) => {
        resolve({ groupings: data.data.content, page: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllWithAccess(groupingId, filterOutLeafGroups) {
    return new Promise((resolve, reject) => {
      let options = filterOutLeafGroups ? '?filterOutLeafGroups=true' : ''
      axios.get(`${ROOT}groupings/${groupingId}/getAll${options}`, {metadata: {serviceCall: 'GroupingsService.getAllWithAccess'}}).then((data) => {
        resolve({ groupings: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }


  static getMoveTargetsFor(deviceGroupingId) {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groupings/move-targets-for/${deviceGroupingId}`, {metadata: {serviceCall: 'GroupingsService.getMoveTargetsFor'}}).then((data) => {
        resolve({ groupings: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static listAll() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groupings/listAll`, {metadata: {serviceCall: 'GroupingsService.listAll'}}).then((data) => {
        resolve({ groupings: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getFirstVisible() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groupings/firstVisible`, {metadata: {serviceCall: 'GroupingsService.getFirstVisible'}}).then((data) => {
        resolve({ grouping: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static get(groupingId, includeAMT=false) {
    return new Promise((resolve, reject) => {
      let detailParms = includeAMT ? '?includeAMTDevices=true' : '';
      axios.get(`${ROOT}groupings/${groupingId}${detailParms}`, {metadata: {serviceCall: 'GroupingsService.get'}}).then((data) => {
        resolve({ grouping: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getEventReport(groupId, groupingId, startAtDate, endAtDate, summary) {
    return new Promise((resolve, reject) => {
      const query = groupingId == -1 ?
        `startAtDate=${startAtDate}&endAtDate=${endAtDate}&deviceGroupId=${groupId}&summary=${summary}` :
        `startAtDate=${startAtDate}&endAtDate=${endAtDate}&deviceGroupingId=${groupingId}&summary=${summary}`;
      axios.get(`${ROOT}reports/event-report?${query}`).then((data) => {
        resolve({ report: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAlertCountCSV(groupId, groupingId, startAtDate, endAtDate, summary) {
    return new Promise((resolve, reject) => {
      const query = groupingId == -1 ?
        `startAtDate=${startAtDate}&endAtDate=${endAtDate}&deviceGroupId=${groupId}&summary=${summary}` :
        `startAtDate=${startAtDate}&endAtDate=${endAtDate}&deviceGroupingId=${groupingId}&summary=${summary}`;
      axios.post(`${ROOT}reports/event-csv-report?${query}`).then((response) => {
        let blob = new Blob([response.data], {type: "application/csv"});
        FileSaver.saveAs(blob, "report.csv");
        resolve();
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getDashboardData(groupingId, timeConstraint) {
    return new Promise((resolve, reject) => {
      const query = `timeConstraint=${timeConstraint}`
      axios.get(`${ROOT}groupings/${groupingId}/dashboard-data?${query}`, {metadata: {serviceCall: 'GroupingsService.getDashboardData'}}).then((data) => {
        resolve({ data: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static save(grouping, metadata) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}groupings/${grouping.id}`, grouping, {metadata: {serviceCall: 'GroupingsService.save'}}).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static add(grouping) {
    return new Promise((resolve, reject) => {
      axios.post(`${ROOT}groupings`, grouping, {metadata: {serviceCall: 'GroupingsService.add'}}).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static archive(groupingId) {
    return new Promise((resolve, reject) => {
      axios.delete(`${ROOT}groupings/${groupingId}`, {metadata: {serviceCall: 'GroupingsService.archive'}}).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static restore(groupingId) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}groupings/restore/${groupingId}`, {metadata: {serviceCall: 'GroupingsService.restore'}}).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static move(groupingId, toParentGroupingId, toParentBusinessStructureId) {
    return new Promise((resolve, reject) => {
      axios.patch(`${ROOT}groupings/move/${groupingId}/to/${toParentGroupingId}/${toParentBusinessStructureId}`, {metadata: {serviceCall: 'GroupingsService.move'}}).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static bulkUpload(file, parentDeviceGroupingId, deviceGroupId) {
    return new Promise((resolve, reject) => {
      const uploadData = new FormData();
      uploadData.append('file', file);

      axios.post(`${ROOT}groupings/bulkadd/${parentDeviceGroupingId}/${deviceGroupId}`, uploadData).then((data) => {
        resolve({ response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

  static getAllMetadataTypes() {
    return new Promise((resolve, reject) => {
      axios.get(`${ROOT}groupings/metadataTypes`, {metadata: {serviceCall: 'GroupingsService.getAllMetadataTypes'}}).then((data) => {
        resolve({ types: data.data, response: data });
      }).catch((err) => {
        reject(err);
      });
    });
  }

}

export default GroupingsService;
